import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

const SearchResultSkeleton = () => {
  return (
    <>
      {[...Array(3)].map((_, index) => (
        <ListItem key={`skeleton-${index}`}>
          <Box display="flex" alignItems="center" width="100%">
            <Box mr={2}>
              <Skeleton variant="rectangular" width={50} height={50} />
            </Box>
            <ListItemText primary={<Skeleton animation="wave" height={24} width="80%" />} />
          </Box>
        </ListItem>
      ))}
    </>
  );
};

export default SearchResultSkeleton; 